import {
  combineReducers
} from "redux";
import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , makeIsLoadingReducer
} from "shared-utility/store/utils/helpers";
import { HEDGE_STATUSES } from "@loanbossinc/component-library";

// ACTIONS

export const ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS = generateDefaultActions("ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS");
export const activeLoansGetByDealAndStatus = payload => makePayload(ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS.value, payload);
function* activeLoansGetByDealAndStatusSaga(payload) {
  const { dealId, loanStatusId } = payload;
  const url = `/loans/getLoansByDealIdAndStatus/${dealId}/${loanStatusId}`;
  yield requestSaga(ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS, url, "GET");
}

export const ACTIVE_LOAN_ADD = generateDefaultActions("ACTIVE_LOAN_ADD");
export const activeLoanAdd = payload => makePayload(ACTIVE_LOAN_ADD.value, payload);
function* activeLoanAddSaga(payload) {
  const url = "/loans/new";
  const callback = handleCallback(payload);
  yield requestSaga(ACTIVE_LOAN_ADD, url, "POST", payload);
  yield callback();
}

export const ACTIVE_LOAN_GET_ACTIVE_HEDGES = generateDefaultActions("ACTIVE_LOAN_GET_ACTIVE_HEDGES");
export const activeLoanGetActiveHedges = payload => makePayload(ACTIVE_LOAN_GET_ACTIVE_HEDGES.value, payload);
function* activeLoanGetActiveHedgesSaga(payload) {
  const url = `/getHedgesByDealId/${payload.dealId}/${HEDGE_STATUSES.ACTIVE}`;
  yield requestSaga(ACTIVE_LOAN_GET_ACTIVE_HEDGES, url);
}

export const ACTIVE_LOAN_GET_WATCH_HEDGES = generateDefaultActions("ACTIVE_LOAN_GET_WATCH_HEDGES");
export const activeLoanGetWatchHedges = payload => makePayload(ACTIVE_LOAN_GET_WATCH_HEDGES.value, payload);
function* activeLoanGetWatchHedgesSaga(payload) {
  const url = `/getHedgesByDealId/${payload.dealId}/${HEDGE_STATUSES.WATCH}`;
  yield requestSaga(ACTIVE_LOAN_GET_WATCH_HEDGES, url);
}

const initialState = {
  loans: [],
  createdLoan: {},
  activeHedges: {},
  watchHedges: {}
};

// REDUCER

function activeLoanModuleReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS.success:
      return defaultReturn(state, payload.loans, "loans");

    case ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS.error:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case ACTIVE_LOAN_ADD.success:
      ToastSuccess("Save successful");

      return defaultReturn(state, payload.data, "createdLoan");

    case ACTIVE_LOAN_GET_ACTIVE_HEDGES.success:
      return defaultReturn(state, payload.hedges, "activeHedges");

    case ACTIVE_LOAN_GET_WATCH_HEDGES.success:
      return defaultReturn(state, payload.hedges, "watchHedges");

    default:
      return state;
  }
}

export default combineReducers({
  activeLoanModuleReducer,
  activeLoanModuleDealLoading: makeIsLoadingReducer(ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS)
});

// SAGA

export function* activeLoanModuleSaga() {
  yield takeLatest(ACTIVE_LOAN_ADD.value, activeLoanAddSaga);
  yield takeLatest(ACTIVE_LOANS_GET_BY_DEAL_AND_STATUS.value, activeLoansGetByDealAndStatusSaga);
  yield takeLatest(ACTIVE_LOAN_GET_ACTIVE_HEDGES.value, activeLoanGetActiveHedgesSaga);
  yield takeLatest(ACTIVE_LOAN_GET_WATCH_HEDGES.value, activeLoanGetWatchHedgesSaga);
}
